import { useEffect, useState } from 'react';
import { MINUTE, SECOND } from 'time-constants';

export const useCountdown = (expirationTime: Date) => {
  const initialValue = new Date(expirationTime).getTime() - Date.now();
  const [countdown, setCountdown] = useState(isNaN(initialValue) ? 0 : initialValue);

  useEffect(() => {
    if (expirationTime) {
      const expirationTimeUtc = expirationTime.getTime();
      const interval = setInterval(() => {
        const remainedTime = expirationTimeUtc - Date.now();

        if (remainedTime >= 0) {
          setCountdown(remainedTime);
        } else {
          clearInterval(interval);
        }
      }, SECOND);

      return () => clearInterval(interval);
    }
  }, [expirationTime]);

  const minutes = Math.floor(countdown / MINUTE);
  const seconds = Math.floor((countdown - minutes * MINUTE) / SECOND);
  const text = isNaN(minutes) || isNaN(seconds) ? '' : `${minutes}:${String(seconds).padStart(2, '0')}`;

  return {
    minutes,
    seconds,
    countdown,
    text,
  };
};
